import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus-secondary-next",
  "use": "icon-plus-secondary-next-usage",
  "viewBox": "0 0 30 28",
  "content": "<symbol viewBox=\"0 0 30 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus-secondary-next\">\n<path d=\"M0.78125 16.6836H29.2461V11.2969H0.78125V16.6836ZM12.3203 27.7031H17.6797V0.277344H12.3203V27.7031Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol